<template>
  <div id="contents" class="maintenance contents">
    <div class="maint wrap_maintenance">
      <i></i>
      <div class="title_wrapper">
        <span class="maintenance_title">
          {{ $t('maintenance.currently') }}&nbsp;
        </span>
        <span v-if="name" class="maintenance_shop">{{ name }}</span>
      </div>
      <span class="maintenance_title_after">
        {{ $t('maintenance.under_maintenance') }}
      </span>
      <div class="sub_title_wrapper">
        <div class="sub_title">
          {{ $t('maintenance.sorry_for_the_inconvenience') }}
          <br />
          {{ $t('maintenance.shop_unavailable_due_to_maintenance') }}
        </div>
      </div>
      <div v-if="message">
        <span class="bar"></span>
        <div class="date_range" v-html="message.replace(/\n/g, '<br />')"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { formatDateRange } from '@/utils/date'

export default {
  name: 'MaintenanceView',
  components: {},
  computed: {
    ...mapGetters('main', [
      'name',
      'startDateTime',
      'endDateTime',
      'message',
      'shopSeq'
    ]),
    formattedDateRange() {
      return formatDateRange(this.startDateTime, this.endDateTime)
    }
  },
  data() {
    return {}
  },
  methods: {
    ...mapActions('main', ['getInitData'])
  }
}
</script>
<style lang="scss" scoped>
.maint {
  box-sizing: border-box;
  padding-top: 83px;
  padding-bottom: 67px;
  text-align: center;
  width: 100%;
  margin: 0 auto;
  i {
    display: inline-block;
    width: 128px;
    height: 115px;
    background-image: url('../assets/images/intro/ico_maintenance.png');
  }
  .title_wrapper {
    margin-top: 40px;
    font-size: 24px;
    font-weight: bold;
  }
  .maintenance_title {
    color: #000;
    font-size: 24px;
    font-weight: bold;
  }
  .maintenance_title_after {
    color: #000;
    font-size: 24px;
    font-weight: bold;
    margin-top: 5px;
  }
  .maintenance_shop {
    color: #6134f1;
  }
  .sub_title_wrapper {
    line-height: 1.4;
    font-size: 18px;
    margin-top: 17px;
    color: #747a86;
  }
  h2 {
    margin-top: 20px;
    font-size: 18px;
    font-weight: bold;
    color: #2c2b2f;
  }
  span {
    display: inline-block;
    margin-top: 13px;
    color: #6134f1;
  }
  .bar {
    /* Rectangle 5 */
    width: 300px;
    height: 1px;
    margin: 20px 0;
    background: #edeff2;
  }
  .date_range {
    color: black;
    font-size: 18px;
    line-height: 20px;
  }
}
@media all and (max-width: 768px) {
  .maint {
    box-shadow: none;
    border: none;
    padding-top: 83px;
    width: 100%;
    i {
      width: 128px;
      height: 115px;
      background-size: 128px 115px;
    }
    .title_wrapper {
      margin-top: 40px;
      font-size: 20px;
      font-weight: bold;
    }
    .maintenance_title {
      color: #000;
      font-size: 20px;
      font-weight: bold;
    }
    .maintenance_title_after {
      color: #000;
      font-size: 20px;
      font-weight: bold;
      margin-top: 5px;
    }
    .maintenance_shop {
      color: #6134f1;
    }
    .sub_title_wrapper {
      line-height: 1.4;
      font-size: 14px;
      margin: 31px 0 0 0;
      color: #747a86;
    }
    h1 {
      margin-top: 40px;
      font-size: 20px;
    }
    p {
      margin-top: 15.5px;
      font-size: 14px;
    }
    h2 {
      margin-top: 20px;
      font-size: 14px;
    }
    .date_range {
      font-size: 14px;
    }
  }
}
</style>
